<div data-testid="ordinary-spu-page" class="p-4 flex-table-page routed-flex-table-page">
  <!-- Search Form -->
  <app-search-form
    data-testid="ordinary-spu-search-form"
    [searchFormat]="searchFormConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        [testId]="'ordinary-spu-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
      <app-status-filter
        [primaryButton]="primaryButton()"
        (primaryButtonClick)="onAdd()"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <advanced-data-table
      data-testid="ordinary-spu-table"
      #advancedTable
      [dataSource]="spus()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [rows]="searchParams().size"
      [first]="(searchParams().page - 1) * searchParams().size"
      [totalRecords]="totalRecords()"
      [loading]="loading()"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
      [showInternalColumnConfigButton]="false"
      class="w-full"
    >
    <!-- Custom Template for Type, Category, and Date -->
    <ng-template
      #customTemplate
      let-value
      let-rowData="rowData"
      let-column="column"
    >
      @if (column && column.template === "dateTemplate") {
        <span class="text-xs text-gray-600">
          {{ formatDateTime(value) }}
        </span>
      } @else if (column && column.prop === "type") {
        <span class="text-xs flex items-center justify-center">
          {{ getTypeDisplayText(value) }}
        </span>
      } @else if (column && column.template === "categoryTemplate") {
        <span
          class="text-xs text-gray-700 truncate cursor-help"
          [pTooltip]="value"
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        >
          {{ value }}
        </span>
      }
    </ng-template>

    <!-- Custom Status Template -->
    <ng-template #statusTemplate let-status>
      <div class="flex items-center justify-center gap-1 w-full">
        <p-tag
          data-testid="ordinary-spu-status-tag"
          [value]="getStatusDisplayText(status) | translate"
          [severity]="getStatusSeverity(status)"
          styleClass="status-tag"
          [ngStyle]="getStatusStyle(status)"
          [pTooltip]="
            status
              ? ('common.table.status.active' | translate)
              : ('common.table.status.inactive' | translate)
          "
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        />
      </div>
    </ng-template>

    <!-- Custom Actions Template -->
    <ng-template #actionsTemplate let-spu>
      <div class="flex gap-2 justify-center">
        @if (canRead()) {
          <app-button
            [testId]="'ordinary-spu-action-view-' + spu.id"
            class="action-view"
            [label]="'common.actions.view' | translate"
            type="action"
            (emitOnClick)="onView(spu)"
          ></app-button>
        }
        @if (canUpdate()) {
          <app-button
            [testId]="'ordinary-spu-action-edit-' + spu.id"
            class="action-edit"
            [label]="'common.actions.edit' | translate"
            type="action"
            (emitOnClick)="onEdit(spu)"
          ></app-button>
        }
        @if (canApprove()) {
          <app-button
            [testId]="'ordinary-spu-action-toggle-status-' + spu.id"
            [class]="spu.status ? 'action-disable' : 'action-enable'"
            [label]="
              (spu.status
                ? 'common.table.actions.deactivate'
                : 'common.table.actions.activate'
              ) | translate
            "
            type="action"
            (emitOnClick)="spu.status ? onDisable(spu) : onEnable(spu)"
          ></app-button>
        }
        @if (canDelete()) {
          <app-button
            [testId]="'ordinary-spu-action-delete-' + spu.id"
            class="action-delete"
            [label]="'common.actions.delete' | translate"
            type="action"
            [disabled]="spu.status"
            [tooltip]="
              spu.status ? 'goods.spu.messages.cannot_delete_active' : ''
            "
            tooltipPosition="top"
            [showDelay]="300"
            (emitOnClick)="onDelete(spu)"
          ></app-button>
        }
      </div>
    </ng-template>
    </advanced-data-table>
  </div>
</div>

<!-- Toast Messages -->
<p-toast data-testid="ordinary-spu-toast"></p-toast>

<!-- Shared Confirmation Dialog -->
<app-confirmation-dialog
  [testId]="'ordinary-spu-confirmation-dialog'"
  [(visible)]="showConfirmationDialog"
  [title]="dialogTitle"
  [message]="dialogMessage"
  [buttons]="dialogButtons"
  (emitOnClick)="onConfirmatiButtonClick($event)"
></app-confirmation-dialog>
